import React, { useState, useEffect } from 'react';
import { HierarchyTable, Column } from '../../utils/commonUtils/HierarchyTable';
import TreeNode from '../../utils/commonUtils/BMSPPrimereactFork/treenode/TreeNode';
import { Input } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import './HierarchyTree-Common.scss';
import { HOCLocalization } from '../../utils/HOC/HOCLocalization';

export interface ISelectedNode {
  checked: boolean;
  partialChecked: boolean;
}
export interface ISelectedNodeMap {
  [key: string]: ISelectedNode;
}
interface IHierarchyTreeProps {
  handleChange: (event: any, type: string) => void;
  selectedNode: ISelectedNodeMap;
  organisationHierarchy: TreeNode[];
  loading: boolean;
  onExpand(e: { originalEvent: Event; node: TreeNode }): void;
}

export const HierarchyTree = (props: IHierarchyTreeProps) => {
  const [globalFilter, setGlobalFilter] = useState<string>('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [t] = useTranslation();

  useEffect(() => {
    let total = 0;

    const countTotalRecords = (node: TreeNode): number => {
      if (node.children.length === 0) {
        return 0;
      }

      return (
        node.children.length +
        node.children
          .map((child: TreeNode) => countTotalRecords(child))
          .reduce((a: number, b: number) => a + b)
      );
    };

    for (const iterator of props.organisationHierarchy) {
      total += countTotalRecords(iterator) + 1;
    }
    setTotalRecords(total);
  }, [props.organisationHierarchy]);

  const getHeader = () => {
    return (
      <div className="hierarchy-view-header">
        <Input
          placeholder={t('searchFor')}
          onChange={(e) => setGlobalFilter(e)}
          search={true}
        />
        <span className="node-count">
          {totalRecords} {t('nodes')}
        </span>
      </div>
    );
  };

  return (
    <div className="hierarchy-view">
      <HierarchyTable
        loading={props.loading}
        value={props.organisationHierarchy}
        onExpand={props.onExpand}
        columnResizeMode="expand"
        selectionMode="checkbox"
        onSelectionChange={(e) => props.handleChange(e.value, 'node')}
        selectionKeys={props.selectedNode}
        filterMode="strict"
        globalFilter={globalFilter}
        header={getHeader()}
      >
        <Column
          style={{ fontWeight: 'bold' }}
          field="name"
          header={t('name')}
          expander={true}
        />
        <Column field="type" header={t('type')} />
      </HierarchyTable>
    </div>
  );
};

export default HOCLocalization(HierarchyTree);
